module.exports = __webpack_public_path__ + "img/b1b8ae7.svg";